import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';

/**
 * Калькулятор всегда открывается сверху.
 *
 * Браузер сам возвращает прежнее положение прокрутки при перезагрузке страницы,
 * а содержимое калькулятора появляется позже — из-за этого открытие бросало
 * менеджера в середину расчёта, хотя заполнять нужно с адреса и товаров.
 * Восстановление выключается, и страница один раз ставится в начало.
 */
if (typeof window !== 'undefined') {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  window.scrollTo(0, 0);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

